/* globals google */
'use strict';

import styles from './mapStyles';
import { appendToUrl } from 'util/common';
import { applyRendering } from 'util/render';
import StoreHours from '../storeLocator/storeHours';
import { woosmapInitFindYourStore } from 'woosmap';

/**
 * Creates the HTML to show information about the store
 * @param {Object} store The store to show information about
 */
function createHTMLForInfoWindow (store) {
    var storeData = {
        latitude: store.latitude,
        longitude: store.longitude,
        URL: store.URL,
        name: store.name,
        address2: store.address2,
        postalCode: store.postalCode,
        city: store.city,
        stateCode: store.stateCode,
        distance: store.distance,
        phone: store.phone,
        hours: $('#' + store.ID + ' .js-store-hours-current').html()
    };
    var infoWindowHtml = applyRendering('storeName', storeData);
    infoWindowHtml += applyRendering('storeHours', storeData);
    if (store.distance) {
        infoWindowHtml += applyRendering('storeDistance', storeData);
    }
    if (store.phone) {
        infoWindowHtml += applyRendering('storePhone', storeData);
    }
    return infoWindowHtml;
}

/**
 * Uses google maps api to render a map
 */
function maps (initialCoords = {lat: 37.09024, long: -95.712891}) {
    var labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var labelIndex = 0;
    var infowindow = new google.maps.InfoWindow();

    // Init U.S. Map in the center of the viewport
    var latlng = new google.maps.LatLng(initialCoords.lat, initialCoords.long);
    var mapOptions = {
        scrollwheel: false,
        zoom: 12,
        center: latlng,
        streetViewControl: false,
        styles
    };

    let map = new google.maps.Map($('.js-map-canvas')[0], mapOptions);
    var mapdiv = JSON.parse($('.js-map-canvas').attr('data-locations'));

    var bounds = new google.maps.LatLngBounds();

    // This is needed to set the zoom after fitbounds,

    var markerUrl = {
        url: $('.js-map-canvas').data('marker-url'),
        labelOrigin: new google.maps.Point(8, 9)
    };

    const markers = [];
    Object.keys(mapdiv).forEach(function (key) {
        var item = mapdiv[key];
        var storeLocation = new google.maps.LatLng(item.latitude, item.longitude);

        let label = '';
        let increment = Math.floor(labelIndex >= labels.length ? labelIndex / labels.length : 0);
        let index = Math.floor(labelIndex > labels.length ? (labelIndex - Math.floor(labelIndex / labels.length).toFixed(0) * labels.length) : labelIndex);
        label = labels[index % labels.length] + (increment > 0 ? increment + '' : '');

        labelIndex++;

        var marker = new google.maps.Marker({
            position: storeLocation,
            map: map,
            title: item.name,
            icon: markerUrl,
            label: { text: label, color: 'white', fontSize: '9px' }
        });
        markers.push(marker);

        marker.addListener('click', function () {
            infowindow.setOptions({
                content: createHTMLForInfoWindow(item)
            });
            $('body').trigger('analytics:clickonBlackMarker', item);
            infowindow.open(map, marker);
        });

        $("a[latitude='" + item.latitude + "'][longitude='" + item.longitude + "']").on('click', function (e) {
            e.preventDefault();
            infowindow.setOptions({
                content: createHTMLForInfoWindow(item)
            });
            infowindow.open(map, marker);
            // $('body').trigger('analytics:clickonBlackMarker', item);
        });
        // Create a minimum bound based on a set of storeLocations
        bounds.extend(marker.position);
    });

    // Fit the all the store marks in the center of a minimum bounds when any store has been found.
    if (mapdiv && mapdiv.length !== 0) {
        map.fitBounds(bounds);
    }

    // Set map coordinates on result pin click
    const $results = $('.results');
    $results.on('click', '.store-result-marker-button', (e) => {
        map.setCenter({
            lat: Number($(e.currentTarget).data('store-coords').split(',')[0]),
            lng: Number($(e.currentTarget).data('store-coords').split(',')[1])
        });

        map.setZoom(20);

        $('html, body').animate({
            scrollTop: $('.js-map-canvas').offset().top - $(window).height() / 3
        }, 500);

        e.preventDefault();
    });
}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function updateStoresResults (data) {
    var $resultsDiv = $('.store-results-container');
    var $mapDiv = $('.js-map-canvas');
    var hasResults = data.stores.length > 0;
    $('.results').attr('data-current-radius', data.currentStep);

    $resultsDiv.empty()
        .closest('.results')
        .data('has-results', hasResults)
        .data('radius', data.radius)
        .data('search-key', data.searchKey);

    $mapDiv.attr('data-locations', data.locations);

    if ($mapDiv.data('has-google-api')) {
        const coords = {};
        const searchKeys = $('.results').data('search-key');

        if (searchKeys.lat && searchKeys.long) {
            coords.lat = searchKeys.lat;
            coords.long = searchKeys.long;
        }
        maps(coords);
    } else {
        $('.js-store-locator-no-apiKey').show();
    }

    if (data.storesResultsHtml) {
        $resultsDiv.append(data.storesResultsHtml);
    }

    $('.store-results-number').text($('.store-result-container').length + '');
    if (!data.isFromInit) {
        $('.store-results-number-container').removeClass('hidden');
    }

    if (data.showMoreEnabled) {
        $('.js-more-stores-button').removeClass('hidden');
    } else {
        $('.js-more-stores-button').addClass('hidden');
    }

    StoreHours.run();
}

/**
 * Search for stores with new zip code
 * @param {HTMLElement} element - the target html element
 * @param {Object.<string, float>} coords - the coordinates
 * @param {boolean} refreshSteps - true to start the search from the original radius
 * @returns {boolean} false to prevent default event
 */
function search (element, coords, refreshSteps) {
    var $form = element.closest('.store-locator');
    var intFilter = $form.find('input[name="int_filter"]').is(':checked');
    var iuoFilter = $form.find('input[name="iuo_filter"]').is(':checked');

    var radius = parseInt($('.results').attr('data-current-radius')) - 1; // -1 to stay in the current step
    if (refreshSteps) {
        radius = parseInt($('.results').attr('data-base-step'));
    }

    var urlParams = {
        radius,
        lat: coords.lat,
        long: coords.long,
        intFilter: intFilter,
        iuoFilter: iuoFilter
    };

    var url = appendToUrl($form.attr('action'), urlParams);

    var dialog = element.closest('.in-store-inventory-dialog');
    var spinner = dialog.length ? dialog.spinner() : $.spinner();
    spinner.start();
    $.ajax({
        url: url,
        type: $form.attr('method'),
        dataType: 'json',
        success: function (data) {
            spinner.stop();
            updateStoresResults(data);
            $('.select-store').prop('disabled', true);
            $('body').trigger('storeLocator:searchWithZipCode', data); // TODO - Seearch for stores with new code
        }
    });
    return false;
}

function refreshSearch (radius) {
    var searchKeys = $('.results').data('search-key');
    var url = $('.store-locator').attr('action');
    var urlParams = {};

    if (searchKeys.postalCode) {
        urlParams = {
            radius: radius,
            postalCode: searchKeys.postalCode
        };
    } else if (searchKeys.lat && searchKeys.long) {
        urlParams = {
            radius: radius,
            lat: searchKeys.lat,
            long: searchKeys.long
        };
    }
    var intFilter = $('.store-locator').find('input[name="int_filter"]').is(':checked');
    var iuoFilter = $('.store-locator').find('input[name="iuo_filter"]').is(':checked');
    urlParams.intFilter = intFilter;
    urlParams.iuoFilter = iuoFilter;

    url = appendToUrl(url, urlParams);

    var spinner = $.spinner();
    spinner.start();
    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            spinner.stop();
            updateStoresResults(data);
            $('.select-store').prop('disabled', true);
        }
    });
}

module.exports = {
    init: function () {
        window.storeLocator = {};
        window.storeLocator.previousQuery = '';

        if ($('.js-map-canvas').data('has-google-api')) {
            const coords = {};
            const searchKeys = $('.results').data('search-key');

            if (searchKeys.lat && searchKeys.long) {
                coords.lat = searchKeys.lat;
                coords.long = searchKeys.long;
            }

            maps(coords);
        } else {
            $('.js-store-locator-no-apiKey').show();
        }
    },

    woosmapInitFindYourStore: woosmapInitFindYourStore(),

    initialDataSearch: function () {
        if ($('.store-locator-results').data('woosmap-suggestion')) {
            return;
        }
        let element = $('.store-locator input[name=postalCode]');
        let name = element.val();
        if (name && name !== '' && name !== undefined && name !== null) {
            $.spinner().start();

            var url = $('.store-locator').attr('action');
            var coords = $('.store-locator-results').data('geolocation').split(',');

            var urlParams = {
                radius: 1,
                lat: coords[0],
                long: coords[1],
                intFilter: true,
                iuoFilter: true
            };

            url = appendToUrl(url, urlParams);

            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    $.spinner().stop();
                    $('body').trigger('storeLocator:searchWithZipCode', data); //TODO - Initial search for stores
                    data.isFromInit = true;
                    updateStoresResults(data);
                    $('.select-store').prop('disabled', true);
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    },

    detectLocation: function () {
        // clicking on detect location.
        $('.js-detect-location').on('click', function () {
            $('.store-locator').find('.localities-empty-button').trigger('click');
            $.spinner().start();

            navigator.geolocation.getCurrentPosition(function (position) {
                var $detectLocationButton = $('.js-detect-location');
                var url = $detectLocationButton.data('action');
                var radius = parseInt($('.results').attr('data-current-radius')) - 1; // Present step skip

                var intFilter = $('.store-locator').find('input[name="int_filter"]').is(':checked');
                var iuoFilter = $('.store-locator').find('input[name="iuo_filter"]').is(':checked');

                var urlParams = {
                    radius: radius,
                    lat: position.coords.latitude,
                    long: position.coords.longitude,
                    intFilter: intFilter,
                    iuoFilter: iuoFilter
                };

                url = appendToUrl(url, urlParams);
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $.spinner().stop();
                        $('body').trigger('storeLocator:geolocationSucceeded', data);
                        updateStoresResults(data);
                        $('.select-store').prop('disabled', true);
                    }
                });
            }, function () {
                $.spinner().stop();
            });
        });
    },

    search: function () {
        $('.store-locator-container form.store-locator').submit(function (e) {
            e.preventDefault();
        });
        $('.store-locator-container .btn-storelocator-search[type="button"]').click(function (e) {
            e.preventDefault();
        });
    },

    selectStore: function () {
        $('.store-locator-container').on('click', '.select-store', function (e) {
            e.preventDefault();
            var selectedStore = $(':checked', '.results-card .results');
            var data = {
                storeID: selectedStore.val(),
                searchRadius: $('#radius').val(),
                searchPostalCode: $('.results').data('search-key').postalCode,
                storeDetailsHtml: selectedStore.siblings('label').find('.store-details').html(),
                event: e
            };

            $('body').trigger('store:selected', data);
        });
    },

    updateSelectStoreButton: function () {
        $('body').on('change', '.select-store-input', function () {
            $('.select-store').prop('disabled', false);
        });
    },

    showMore: function () {
        $('body').on('click', '.js-store-locator-more-results', function (e) {
            e.preventDefault();
            var radius = parseInt($('.results').attr('data-current-radius'));
            refreshSearch(radius);
        });
    },
    observeShopTypeChange: function () {
        $('.store-locator input:checkbox').change(function () {
            var radius = parseInt($('.results').attr('data-current-radius')) - 1; // -1 to prevent skipping to next step
            refreshSearch(radius);
        });
    },

    initStoreHours: function () {
        StoreHours.run();
    },

    woosmapListener: function () {
        $('body').on('woosmap:chooseOptionFindYourStore', function (e, selection) {
            if (selection.geometry && selection.geometry.location.lat && selection.geometry.location.lng) {
                const coords = {
                    lat: selection.geometry.location.lat,
                    long: selection.geometry.location.lng
                };

                search($('.store-locator-container form.store-locator'), coords, true);
            } else {
                // Log failure to the console as warning
                console.warn('Geocoding via Woosmap failed.');
                $.spinner().stop();
            }
        });
    },

    // If previous search from footer wasn't done through woosmap suggestion, open the dropdown once again on landing
    showWoosmapDropdown: function () {
        if ($('.store-locator-results').data('woosmap-suggestion')) {
            $('body').trigger('woosmap:openDropdownStoreLocator');
        }
    }
};
